import Swiper from "swiper/bundle";





/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                  test Slider 
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

var testSlider;

function createtestSlider(swiperEl) {
  const nextele = swiperEl.querySelector(".nav-right");
  const prevele = swiperEl.querySelector(".nav-left");

  testSlider = new Swiper(swiperEl, {
    speed: 800,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },


    navigation: {
      nextEl: nextele,
      prevEl: prevele
    },
  });
}



export { createtestSlider }